"use client";

import { c as _c } from "react/compiler-runtime";
import { LogOut } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import { useActionHandler } from "@/shared/hooks/use-action-handler";
import { stopImpersonationAction } from "../impersonation-actions";
const StopImpersonationButton = () => {
  const $ = _c(7);
  const {
    handleAction,
    loading
  } = useActionHandler();
  let t0;
  if ($[0] !== handleAction) {
    t0 = () => handleAction(stopImpersonationAction, undefined, {
      onSuccess: _temp
    });
    $[0] = handleAction;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleStop = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LogOut className="size-3.5" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = loading ? "Ending..." : "End impersonation";
  let t3;
  if ($[3] !== handleStop || $[4] !== loading || $[5] !== t2) {
    t3 = <Button size="sm" variant="secondary" onClick={handleStop} disabled={loading} className="h-7 gap-1.5 bg-white text-destructive hover:bg-white/90">{t1}{t2}</Button>;
    $[3] = handleStop;
    $[4] = loading;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default StopImpersonationButton;
function _temp(data) {
  if (data?.redirectTo) {
    window.location.href = data.redirectTo;
  }
}